import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { UserAllRegistrations } from '../../../shared/user/base';
import { EventRegistration } from '../../modules/registration/EventRegistration';
import { Fetcher, isLogicError, isResourceError, useFetcher, useUserSafe } from '../../utils';
import { LogicError } from '../../utils/errorHandling';
import { RegistrationClosed } from './RegistrationClosed';

export const EditRegistration: FC<{ readonly allRegistrations: UserAllRegistrations }> = ({
  allRegistrations,
}) => {
  const { id: idStr } = useParams<{ id: string }>();
  const user = useUserSafe();
  let { id } = user;

  if (idStr) {
    id = Number.parseInt(idStr, 10);
  }

  const userDetails = allRegistrations.users.find((u) => u.id === id);
  const request = useFetcher(async () => {
    return await api.getUserActiveRegistration(id as unknown as number);
  }, [id]);

  if (request.error && isLogicError(request.error, LogicError.RegistrationClosed)) {
    return <RegistrationClosed />;
  }

  const bornAt: Date | 'child' | null = userDetails?.child ? 'child' : userDetails?.bornAt || null;

  if (request.error && isResourceError(request.error, 'Registration')) {
    return <EventRegistration bornAt={bornAt} targetUserId={id} />;
  }

  if (!request.success) {
    return <Fetcher result={request} />;
  }

  return (
    <EventRegistration
      bornAt={bornAt}
      inputUser={userDetails}
      registration={request.data}
      targetUserId={request.data.user.id}
    />
  );
};
